import styled from 'styled-components'

import theme from 'theme_'
import { SubInfoBlock } from '../../../styles'

export const ConnectedAppsContainer = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  row-gap: ${theme.spacing.xs};
  column-gap: ${theme.spacing.xs};
  grid-template-columns: 1fr 1fr;

  @media ${theme.devices.tablet} {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }

  @media ${theme.devices.mediumDesktop} {
    row-gap: ${theme.spacing.xs};
    column-gap: ${theme.spacing.xs};
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  }
`

export const ConnectedAppsInfoContainer = styled(SubInfoBlock)`
  height: auto;
  width: 100%;
  margin-top: ${theme.spacing.md};
  padding: ${theme.spacing.md};
  text-align: center;
`
